import { h, render } from 'preact';
import picostyle from 'picostyle';

const style = picostyle(h);

export const Wrapper = style('div')((props) => {
    const { position, style } = props;

    return {
        position: 'fixed',
        [position || 'right']: '0px',
        bottom: '0px',
        margin: '15px',
        padding: '40px',
        'background-color': '#fff',
        'box-shadow': '7px 7px 25px 0 rgba(0, 0, 0, 0.15), 1px 1px 3px 0 rgba(0, 0, 0, 0.1)',
        fontSize: '13px',
        zIndex: '1000',

        '@media (max-width: 479px)': {
            left: '0px',
            margin: '5px',
            padding: '30px',
        },
        ...style,
    };
});

export const Title = style('h2')({
    marginTop: '0px',
    marginBottom: '5px',
    color: '#000',
    fontSize: '21px',
    lineHeight: '1.2',
    fontWeight: 'bold',
});

export const Description = style('p')({
  marginTop: '0px',
  marginBottom: '10px !important',
  color: 'rgba(0, 0, 0, 0.75)',
  fontSize: 'inherit',
  lineHeight: '1.6',
});

export const Link = style('a')({
    textDecoration: 'underline',
});
